import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getDemandPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/poptavka",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
